__turbopack_context__.v({
  "cadre": "HhQMvW_cadre",
});
